import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { questions } from './config';
import { ScreeningModuleStore } from 'Core_Pages/Screening/ScreeningModuleStore';
import { StyledCircularProgress } from 'Core_Components/LoadingWrapper/styles';
import ErrorModal from 'Core_Components/ErrorModal/ErrorModal';
import { HOSWrapper, HOSProgressBar } from './styles';
import { displayDarkStatusBar } from 'Core_Helpers/statusBar';
import { HOSQuestionMap } from './HOSQuestionType';

function AdultHOSAssessment() {
  const intl = useIntl();
  const screeningStore = ScreeningModuleStore.Instance().Use();
  const screeningTakerStore = screeningStore.ScreeningForm.Use();
  const { control } = useForm();
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const isLoading = screeningTakerStore.IsLoading || screeningStore.IsLoading;
  const hasError = screeningStore.ScreeningHasError;

  const onCloseErrorModal = () => screeningStore.acknowledgeError();
  const onAnswer = (question, answer) => {
    const nextQuestion = currentQuestion + 1;
    screeningTakerStore.updateAnswer(question, answer);

    if (currentQuestion < questions.length - 1) {
      if (!!questions[nextQuestion].dependencies && !questions[nextQuestion].dependencies?.includes(answer)) {
        setCurrentQuestion(nextQuestion + 1);
      } else {
        setCurrentQuestion(nextQuestion);
      }
    }

    if (screeningTakerStore.IsValid) {
      screeningTakerStore.complete();
    }
  };

  useEffect(() => {
    displayDarkStatusBar();
  }, []);

  if (isLoading) {
    return <StyledCircularProgress />;
  }

  const Component = HOSQuestionMap[questions[currentQuestion]?.questionType];
  const filteredOptions = questions[currentQuestion]?.options;

  return (
    <>
      <HOSWrapper fullScreen open={true} aria-labelledby="screening-title">
        <HOSProgressBar variant="determinate" value={currentQuestion * 20} />
        <Typography id="screening-title" component="h1">
          {intl.formatMessage({ id: 'screenings.adult-well-being' })}
        </Typography>
        <Component
          control={control}
          text={intl.formatMessage({ id: `${questions[currentQuestion]?.textId}` })}
          answerType={questions[currentQuestion]?.answerType}
          filteredOptions={filteredOptions}
          onChange={(answer) => {
            const answerOptionGuid = answer.currentTarget?.name;
            onAnswer(questions[currentQuestion]?.name, answerOptionGuid ? answerOptionGuid : answer);
          }}
          {...questions[currentQuestion]}
        />
      </HOSWrapper>
      <ErrorModal open={hasError} onClose={onCloseErrorModal} />
    </>
  );
}

export default AdultHOSAssessment;
